const FolderPlusOutlined = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='14' height='14' fill='none' viewBox='0 0 14 14'>
    <path
      fill='#25314C'
      d='M10.5 3.646H7.765L6.143 2.025a.44.44 0 0 0-.309-.129H3.501c-1.41 0-2.188.777-2.188 2.188v5.833c0 1.41.777 2.188 2.188 2.188h7c1.41 0 2.188-.777 2.188-2.188V5.834c-.001-1.41-.778-2.188-2.189-2.188m1.313 6.271c0 .92-.393 1.313-1.313 1.313h-7c-.92 0-1.312-.393-1.312-1.313V4.084c0-.92.392-1.313 1.312-1.313h2.152l1.622 1.622a.44.44 0 0 0 .31.128H10.5c.92 0 1.312.393 1.312 1.313zM8.896 7.876a.44.44 0 0 1-.437.437H7.438v1.021a.438.438 0 0 1-.875 0v-1.02h-1.02a.438.438 0 0 1 0-.876h1.02v-1.02a.438.438 0 0 1 .875 0v1.02h1.02c.242 0 .438.196.438.438'
    />
  </svg>
);

export default FolderPlusOutlined;
